import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-kenya-vaf.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorKenyaVaf = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorKenyaVaf, _super);
    function CalculatorKenyaVaf(element) {
        return _super.call(this, element) || this;
    }
    CalculatorKenyaVaf.prototype.init = function () {
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputPurchasePrice = this.element.querySelector('input[name=purchase_price]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.totalMontlyRepayment = this.element.querySelector('.js-monthly-repayment');
        this.totalPurchasePrice = this.element.querySelector('.js-purchase-price');
        this.totalRepayment = this.element.querySelector('.js-total-repayment');
        this.totalInterest = this.element.querySelector('.js-total-interest');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-kenya-vaf__result--terms');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        this.inputPurchasePrice.value = this.formatInputNumber(this.inputPurchasePrice.value);
        this.calculate();
        TooltipsService.initTooltips();
    };
    CalculatorKenyaVaf.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            _this.totalMontlyRepayment.innerHTML = "-";
            _this.totalPurchasePrice.innerHTML = "-";
            _this.totalRepayment.innerHTML = "-";
            _this.totalInterest.innerHTML = "-";
        });
        // Format purchase price while typing
        this.inputPurchasePrice.addEventListener('input', function (e) {
            e.target.value = _this.formatInputNumber(e.target.value);
        });
    };
    CalculatorKenyaVaf.prototype.calculate = function () {
        var purchasePrice = parseFloat(this.inputPurchasePrice.value.replace(/\s/g, '')) || 0;
        var interestRate = parseFloat(this.inputInterest.value) || 0;
        var term = parseFloat(this.inputTerm.value) || 0;
        var monthlyPayment = 0;
        if (term > 0) {
            var monthlyRate = interestRate / 1200;
            if (monthlyRate === 0) {
                monthlyPayment = purchasePrice / term;
            }
            else {
                monthlyPayment = -this.PMT(monthlyRate, term, purchasePrice, 0, 0);
            }
        }
        var totalRepayment = monthlyPayment * term;
        var totalInterest = totalRepayment - purchasePrice;
        this.totalPurchasePrice.innerHTML = this.roundFormatter(purchasePrice, 2, true);
        this.totalMontlyRepayment.innerHTML = this.roundFormatter(monthlyPayment, 2, true);
        this.totalRepayment.innerHTML = this.roundFormatter(totalRepayment, 2, true);
        this.totalInterest.innerHTML = this.roundFormatter(totalInterest, 2, true);
    };
    CalculatorKenyaVaf.prototype.PV = function (rate, nper, pmt, fv, type) {
        var pv_value = 0;
        rate = parseFloat(rate);
        nper = parseFloat(nper);
        pmt = parseFloat(pmt);
        fv = parseFloat(fv);
        if (nper == 0) {
            alert("Why do you want to test me with zeros?");
            return (0);
        }
        if (rate == 0) { // Interest rate is 0
            pv_value = -(fv + (pmt * nper));
        }
        else {
            var x = Math.pow(1 + rate, -nper);
            var y = Math.pow(1 + rate, nper);
            pv_value = -(x * (fv * rate - pmt + y * pmt)) / rate;
        }
        return pv_value;
    };
    CalculatorKenyaVaf.prototype.FV = function (rate, nper, pmt, pv, type) {
        var pow = Math.pow(1 + rate, nper), fv;
        pv = pv || 0;
        type = type || 0;
        if (rate) {
            fv = (pmt * (1 + rate * type) * (1 - pow) / rate) - pv * pow;
        }
        else {
            fv = -1 * (pv + pmt * nper);
        }
        return fv;
    };
    CalculatorKenyaVaf.prototype.formatInputNumber = function (value) {
        return value
            .replace(/\s/g, '')
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };
    CalculatorKenyaVaf.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorKenyaVaf.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    CalculatorKenyaVaf.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorKenyaVaf.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorKenyaVaf;
}(Base));
export { CalculatorKenyaVaf };



//////////////////
// WEBPACK FOOTER
// ./components-kenya/calculator-kenya-vaf/calculator-kenya-vaf.component.ts
// module id = 699
// module chunks = 0